import { Index, Show } from 'solid-js'
import { useIndexerStatus } from '../store/search.ts'
import { openBrowse } from '../store/view.ts'

/* the way into browsing without searching first: code search puts the repo list on
   its landing page for exactly this */
export function RepoList() {
  const status = useIndexerStatus()

  return (
    <Show when={status.data?.repos.length}>
      <div class="max-w-2xl w-full">
        <div class="mb-1 px-1 text-xs text-muted-foreground">indexes</div>
        <div class="grid grid-cols-2 gap-1.5 sm:grid-cols-3">
          {/*
            Index, not For. the status query repolls every few seconds and hands back
            freshly parsed objects, and For is keyed by reference - so every poll tore
            the whole list down and rebuilt it, which dropped :hover mid-hover and made
            the tiles flicker under the cursor
          */}
          <Index each={status.data!.repos}>
            {repo => (
              <button
                type="button"
                class="group flex items-center gap-2 border border-border rounded-md bg-card px-2.5 py-2 text-left transition-colors hover:border-ring hover:bg-muted/50"
                onClick={() => openBrowse(repo().name)}
              >
                <div class="i-lucide-folder-git-2 size-4 shrink-0 text-muted-foreground group-hover:text-foreground" />
                <div class="min-w-0 flex-1">
                  <div class="truncate text-xs font-mono">{repo().name}</div>
                  <div class="text-[10px] text-muted-foreground">
                    {repo().files.toLocaleString()}
                    {' files'}
                  </div>
                </div>
              </button>
            )}
          </Index>
        </div>
      </div>
    </Show>
  )
}
